module.exports = {"TXTWCL_This_competition_is_currently__ELL":{"id":"TXTWCL_This_competition_is_currently__ELL","defaultMessage":"この競技は現在ご利用になれません"}}